export const blogPosts = [
  {
    id: 1,
    title: '春季花卉養護指南',
    excerpt: '了解如何在春季照顧您的鮮花，讓花期更持久，綻放更美麗。專業花藝師分享實用養護技巧。',
    date: '2025年1月10日',
    author: 'Monceau 花藝團隊',
    image: 'https://public.readdy.ai/ai/img_res/4e2d21662ea1efb1ff4940c3a506857d.jpg',
    category: '花藝知識'
  },
  {
    id: 2,
    title: '婚禮花藝設計趨勢',
    excerpt: '2025年最新婚禮花藝設計趨勢解析，從色彩搭配到風格選擇，打造夢幻婚禮的完美花藝佈置。',
    date: '2025年1月5日',
    author: 'Monceau 花藝團隊',
    image: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20floral%20design%20trends%2C%20romantic%20bridal%20bouquet%20and%20ceremony%20decoration%2C%20luxury%20wedding%20flowers%2C%20soft%20pastel%20colors%2C%20dreamy%20atmosphere%2C%20professional%20florist%20arrangement&width=800&height=600&seq=monceau-blog-wedding&orientation=landscape',
    category: '婚禮花藝'
  },
  {
    id: 3,
    title: '法式花藝美學解密',
    excerpt: '探索法式花藝的獨特魅力，了解如何運用色彩、質感與線條，創造出優雅而富有層次的花藝作品。',
    date: '2024年12月28日',
    author: 'Monceau 花藝團隊',
    image: 'https://readdy.ai/api/search-image?query=french%20floral%20artistry%20aesthetic%2C%20elegant%20flower%20arrangement%20with%20sophisticated%20design%2C%20luxury%20parisian%20style%20bouquet%2C%20artistic%20composition%2C%20soft%20natural%20lighting%2C%20high-end%20florist%20work&width=800&height=600&seq=monceau-blog-french&orientation=landscape',
    category: '花藝美學'
  }
];
